var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('the-header'),_vm._v(" "),_c('main',{staticClass:"main",class:{ 'main--no-padding': [ 'page_not_found'].includes(_vm.$route.name) }},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('the-footer'),_vm._v(" "),_c('cookie-notification'),_vm._v(" "),_c('confirmation-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351d264c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 699
// module chunks = 5